/*=========================================================================================
Acess Group from Profiles Service:
- Gerente_QI
- Secretária_QI
- Comercial_QI
- AlunoPortal
- TrocaLocal

https://www.npmjs.com/package/vue-acl
AclRule: class with rule builder, the instance receive initial permission.
or: method for add OR condition in rule, e.g: if current permission is public OR admin the rule isPublic equals true
and: method for add AND condition in rule, e.g: if current permission contains user AND inside the rule isLogged equals true
generate: this method should called to create and compile your rule query
==========================================================================================*/

import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import { getProfiles, isLogged } from "../helpers/storage";

import router from "@/router";

Vue.use(AclInstaller);

const LOGGED_ROLE_DEFAULT = ["public", "logged"];

let initialRole = "public";

function _setProfiles() {
  let profiles = getProfiles();

  if (profiles && profiles.length > 0) {
    profiles.push(...LOGGED_ROLE_DEFAULT);
    initialRole = profiles;
  } else if (isLogged()) {
    initialRole = LOGGED_ROLE_DEFAULT;
  }
}

_setProfiles();

export default new AclCreate({
  initial: initialRole,
  notfound: "/not-authorized",
  router,
  acceptLocalRules: true,
  middleware: async acl => {
    _setProfiles();
    acl.change(initialRole);
  },
  globalRules: {
    isAdmin: new AclRule("DBA").generate(),
    isManager: new AclRule("Gerente_QI")
      .or("DBA")
      .generate(),
    isComercial: new AclRule("Comercial_QI")
      .or("Secretária_QI")
      .or("Gerente_QI")
      .or("SecretáriaAC_QI")
      .or("SecretáriaON_QI")
      .or("Secretária_Fund")
      .or("DBA")
      .generate(),
    isSecretary: new AclRule("Secretária_QI")
      .or("Gerente_QI")
      .or("SecretáriaAC_QI")
      .or("SecretáriaON_QI")
      .or("Secretária_Fund")
      .or("DBA")
      .generate(),
    isAcademicPlanning: new AclRule("Remval_QI")
      .or("DBA")
      .generate(),
    isSecretaryAcademicOrOnline: new AclRule("SecretáriaAC_QI")
      .or("SecretáriaON_QI")
      .or("DBA")
      .generate(),
    isSecretaryFundOrOnline: new AclRule("Secretária_Fund")
      .or("SecretáriaON_QI")
      .or("DBA")
      .generate(),
    isSecretaryOnLine: new AclRule("SecretáriaON_QI")
      .or("DBA")
      .generate(),
    isStudentOrSecretary: new AclRule("AlunoPortal")
      .or("DBA")
      .or("Secretária_QI")
      .or("SecretáriaAC_QI")
      .or("Gerente_QI")
      .generate(),
    isLogged: new AclRule("logged").generate(),
    public: new AclRule("public").generate()
  }
});
